import type { ReactNode } from "react";

export default function LanguageBand({
  title,
  copy,
}: {
  /** Wrap the highlighted part in <span>; it renders seafoam. */
  title: ReactNode;
  copy: string;
}) {
  return (
    <section className="px-[6vw] py-[82px] text-white [background:radial-gradient(circle_at_55%_35%,rgba(51,91,255,0.7),transparent_34%),linear-gradient(105deg,#081039_0%,#1628aa_54%,#6237ed_100%)] max-[680px]:px-5">
      <div className="mx-auto grid w-[min(1180px,100%)] grid-cols-[minmax(0,1.45fr)_minmax(300px,0.8fr)] items-center gap-[clamp(50px,7vw,105px)] max-[980px]:grid-cols-1 max-[980px]:gap-7">
        <h2 className="m-0 whitespace-nowrap font-figtree text-[clamp(48px,5.4vw,76px)] font-black uppercase leading-[0.95] tracking-[-0.055em] max-[980px]:whitespace-normal [&_span]:text-teal-500">
          {title}
        </h2>
        <p className="m-0 font-open-sans text-[18px] leading-[1.65] text-white/[0.82]">
          {copy}
        </p>
      </div>
    </section>
  );
}
